export default __webpack_public_path__ + "static/media/snappr_banner_mobile.5a968ccc.png";